/**
 * This function generates a URL based on the provided page name and optional URL.
 * It parses the URL, extracts and handles UTM parameters, and constructs a new URL.
 *
 * @param {string} pageName - The name of the page to be included in the URL path.
 *
 * @returns {string} The constructed URL including the page name, UTM parameters, and other parameters from the original URL.
 */
export const getPageLocation = (pageName: string): string | undefined => {
  if (!pageName) return;
  const url = new URL(window.location.href);
  const utmParams: Record<string, string> = {};
  const otherUtms: Record<string, string> = {};
  const otherParams: Record<string, string> = {};

  url.searchParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams[key] = value;
    } else if (key === 'gclid' || key === 'mktportal') {
      otherUtms[key] = value;
    } else {
      otherParams[key] = value;
    }
  });

  const customPagePath = `${pageName.replace('//', '/')}`;
  const newUrl = new URL(customPagePath, url.origin);

  Object.entries(utmParams).forEach(([key, value]) => {
    newUrl.searchParams.append(key, value);
  });

  Object.entries(otherUtms).forEach(([key, value]) => {
    newUrl.searchParams.append(key, value);
  });

  Object.entries(otherParams).forEach(([key, value]) => {
    newUrl.searchParams.append(key, value);
  });

  if (url.hash) {
    return `${newUrl.toString()}${url.hash}`;
  }

  return newUrl.toString();
};
